import {useMutation} from "@tanstack/react-query";

import {removeRepresentativeContactMutationOptions} from "./remove-representative-contact.mutation-options";

export function useRemoveRepresentativeContact(representativeId: string) {
  return useMutation(removeRepresentativeContactMutationOptions(representativeId));
}
